import React, { Component } from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow, IconButton } from '@material-ui/core';
import { Close as CloseIcon, Search as SearchIcon } from '@material-ui/icons';

import ErrorDialog from './ErrorDialog';

var request = require('../../utilities/NetworkRequest');

export default class WholesalerPickerDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      search_text : '',
      selected_index : -1,
      wholesalers : [],
      is_loading : true,
      error : {
        is_show : false,
        message : ''
      }
    };
  }

  componentDidMount() {
    this.fetchWholesalers();
  }

  fetchWholesalers() {
    const body = { view_id : 'list_wholesaler' };
    request.onRequestData(request.OPTION_API_MAIN, '/list/wholesaler', body, (res_data) => {
      if (res_data.code === 1) {
        const filtered = (res_data.result || []).filter(r => r.is_active === true && r.status_go === 'LIVE');
        this.setState({ wholesalers : filtered, is_loading : false });
      } else {
        this.setState({
          is_loading : false,
          error : {
            is_show : true,
            message : (res_data && res_data.message) ? res_data.message : 'Gagal memuat daftar grosir'
          }
        });
      }
    });
  }

  closeErrorDialog() {
    this.setState({ error : { is_show : false, message : '' } });
  }

  onSearchChange(event) {
    this.setState({ search_text : event.target.value, selected_index : -1 });
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.props.onCloseListener('close', null);
    } else if (event.key === 'Enter' && this.state.selected_index >= 0) {
      event.preventDefault();
      this.onSelectRow(this.state.wholesalers[this.state.selected_index]);
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.setState(prev => ({
        selected_index : Math.min(prev.selected_index + 1, prev.wholesalers.length - 1)
      }));
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.setState(prev => ({
        selected_index : Math.max(prev.selected_index - 1, -1)
      }));
    }
  }

  onSelectRow(row) {
    this.props.onCloseListener('select', row);
  }

  render() {
    const { search_text, selected_index, wholesalers, is_loading, error } = this.state;
    const filtered = wholesalers.filter(item => {
      const q = search_text.trim().toLowerCase();
      if (!q) { return true; }
      return (
        (item.wholesaler_id || '').toLowerCase().includes(q) ||
        (item.wholesaler_name || '').toLowerCase().includes(q)
      );
    });

    return (
      <div onClick={() => this.props.onCloseListener('close', null)} className='process_dialog_root layer_a'>
        { error.is_show && <ErrorDialog body_error={error} onCloseDialog={() => this.closeErrorDialog()} /> }
        <div onClick={(e) => e.stopPropagation()} className='process_dialog_container' style={{ width: 600, maxWidth: '90vw', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
          {/* Header */}
          <div className='title_search_container blue_background'>
            <div className='full_flex default_text_medium_white bold_text'>Pilih Grosir</div>
            <IconButton size='small' onClick={() => this.props.onCloseListener('close', null)} style={{ color: '#fff' }}>
              <CloseIcon fontSize='small' />
            </IconButton>
          </div>

          {/* Search */}
          <div style={{ padding: 12, borderBottom: '1px solid #eee' }}>
            <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#f5f5f5', borderRadius: 4, padding: '6px 10px' }}>
              <SearchIcon fontSize='small' style={{ color: '#999', marginRight: 6 }} />
              <input
                type='text'
                value={search_text}
                onChange={(e) => this.onSearchChange(e)}
                onKeyDown={(e) => this.onKeyDown(e)}
                placeholder='Cari kode atau nama grosir...'
                style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: 13 }}
                className='default_text_normal_gray non_transparent_input'
                autoFocus
              />
            </div>
          </div>

          {/* Table */}
          <div style={{ flex: 1, overflowY: 'auto' }}>
            { is_loading ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 0' }}>
                <div className='default_text_normal_gray'>Memuat daftar grosir...</div>
              </div>
            ) : (
              <Table size='small'>
                <TableHead>
                  <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                    <TableCell style={{ fontWeight: 'bold' }}>Kode Grosir</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Nama Grosir</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtered.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={2} style={{ textAlign: 'center', color: '#999', fontStyle: 'italic', padding: '20px 0' }}>
                        Grosir tidak ditemukan
                      </TableCell>
                    </TableRow>
                  ) : filtered.map((row, idx) => (
                    <TableRow
                      key={row.wholesaler_id}
                      hover
                      onClick={() => this.onSelectRow(row)}
                      onMouseEnter={() => this.setState({ selected_index : idx })}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: selected_index === idx ? '#e3f2fd' : 'transparent'
                      }}
                    >
                      <TableCell>{row.wholesaler_id}</TableCell>
                      <TableCell>{row.wholesaler_name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) }
          </div>

          {/* Footer */}
          <div style={{ padding: '8px 12px', backgroundColor: '#f5f5f5', borderTop: '1px solid #eee', fontSize: 11, color: '#999' }}>
            Tekan ↑↓ untuk navigasi, Enter untuk pilih, Esc untuk tutup
          </div>
        </div>
      </div>
    );
  }

}